import React, {  Fragment, useCallback, useEffect, useRef, useState } from "react";
import { NoRecordsBanner } from "../OopsBanner";
import { CheckSelect } from "../CustomMultiSelect";
import { GetBusinessProducts, getProductCategories } from "../Utilities/BusinessData";
import { UserContext } from "../Definitions/UserContext";
import EditorLoadingSpinner from "../EditorLoadingSpinner";
import ReactDom from "react-dom";
import { utils } from "../../utils/Utils";
import MultiLocationDropdown from "../../VagaroComponent/MultiLocationDropdown";
import isValidLocation from "./IsValidLocation";
import { getClustorBusinessData } from "../Utilities/BusinessData";
import Loader from "../Common/Loader";
import { GenerateProductURLPrefix, productURLVariantTag } from "../Utilities/GetProductInfoFromURL";
import GenericTrackedDropdown from "../GenericTrackedDropdown";
import XIcon from "../Icons/XIcon";


export type CategoryData = {
    id:string,
    name:string,
    parentCategoryId:string,
    productTypeID:string,
    total:number,
}

type CategoryOption ={
    key:string,
    values: {name:string}[]
}


export type ProductFilterData = {
    search:string,
    cat:string,
    brands:string,
    limit:number
}

export function GetProductFilterDataFromString(data:string):ProductFilterData{

    let decoded = decodeURIComponent(data);

    if(decoded.length<5){
        return {search:"",cat:"",brands:"",limit:30};
    }

    try{
        let obj = JSON.parse(decoded) as ProductFilterData;
         return {search:obj.search??"",cat:obj.cat??"",brands:obj.brands??"",limit:obj.limit??30};;
    }
    catch(e){
        return {search:"",cat:"",brands:"",limit:30};
    }


}

export function isDataFiltered(data:ProductFilterData):boolean{

    return data.search!=""||data.cat!=""||data.brands!=""||data.limit<30;

}

const optionSplit = "|:|";

export default function RenderBusinessProducts({ data, layout, userContext, allowMultiLoc }: { data: any, layout: string, userContext: UserContext, allowMultiLoc: any,inCategory?:string }) {


    const isProductListPage = window.location.href.includes("/product-list");



    const filterData = GetProductFilterDataFromString(layout);

    const showFilters = !isDataFiltered(filterData);
    const limitToFirstX = filterData.limit;

    const [bData, setBData] = useState<any>(data);
    const [searchText, setSearchText] = React.useState(filterData.search);

    const [selectedCategory, setRealSelectedCategory] = React.useState<string>(data.cat);

    const setSelectedCategory=(val:string)=>{
        setRealSelectedCategory(val);
       if(isProductListPage){
        let catName = availableCategories.find((c)=>c.id==val)?.name.replaceAll(" ","-").replaceAll("---","-").replaceAll("/","").toLowerCase()??"";
        let newURL = window.location.href.split("product-list")[0]+"product-list/"+catName;

        if(window.history.replaceState)
            window.history.replaceState({}, "", newURL);
        }

    }

    const containerRef = React.useRef<HTMLDivElement>(null);
    const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
    const [showFilterPopup,setShowFilterPopup] = React.useState(false);
    const [brandFilters, setBrandFilters] = React.useState<string[]>(filterData.brands.length>0? filterData.brands.split(",").filter((b:string) => { return b.length > 0 }):[]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [page, setPage] = React.useState(1);


    const [availableCategories, setAvailableCategories] = React.useState<CategoryData[]>([]);
    const [availableBrands, setAvailableBrands] = React.useState< { name: string, id: string }[]>([]);
    const searchRef = React.useRef<HTMLInputElement>(null);

    const [mainLoading,setMainLoading] = React.useState(false);

    const [availableOptions, setAvailableOptions] = React.useState<CategoryOption[]>([]);
    const [optionFilters,setOptionFilters] = React.useState<string[]>([]);

    const businessIndex = GetIndexOfBusinessIdFromMultiLocation(userContext.businessId, userContext);
    const isStencil = bData?.isStenciled;
    const stencilClass = (bData?.isStenciled === true) ? "stenciled" : "";
    const pagesize:number  = 30;
    const totalPages = Math.ceil(bData?.count / pagesize) ?? 1;
    const scrollToRef = useRef(null);

    const [isAddCartLoading, setIsAddCartLoading] = React.useState(false);

    const [dropDownSreachResults,setDropDownSreachResults] = React.useState<any[]>([]);
    const [isDropDownSearchLoading,setIsDropDownSearchLoading] = React.useState(false);

    const [searchTerm,setSearchTerm] = React.useState<string>("");
    const prevSearchVal = useRef<string>("");
    const [useHighRes,setUseHighRes] = React.useState(false);
    //set delay when handling search input to avoid excessive API calls
    function DelayedSearch(term:string){

        prevSearchVal.current = term;
        setSearchTerm(term);
        if(term.length>2  )
            setIsDropDownSearchLoading(true);
        if(term!=""){
        setTimeout(()=>{

            if(term==prevSearchVal.current){
                UpdateSearchResults(term);
            }
        },600);
         }
        else{
           setDropDownSreachResults([]);
           setIsDropDownSearchLoading(false);
        }
    }

    function clearSearch(){
        setSearchTerm("");
        setDropDownSreachResults([]);
        if(searchRef.current)
            searchRef.current.value = "";
    }

    useEffect(() => {


        if(!isProductListPage){ // only use initial filtering before categories if not on product list page


            setBrandFilters(filterData.brands.length>0? filterData.brands.split(",").filter((b:string) => { return b.length > 0 }):[]);
            setSelectedCategory(filterData.cat);
            setSearchText(filterData.search);
            setPage(1);


            UpdateInventoryByFilters(filterData.search,1);
        }


    }, [layout,availableCategories])


    const tryScollUp = () => {

        if(scrollToRef.current)
       ( scrollToRef.current as any).scrollIntoView({ behavior: "smooth" });
    }



    useEffect(() => {

        window.addEventListener("resize", updateRez);
        const observer =  new ResizeObserver((entries) => {

            window.requestAnimationFrame(updateRez);

        });
        if(containerRef.current){
            setIsMobile(containerRef.current.clientWidth < 768);
            observer.observe(containerRef.current);

        }
        getProductCategories(userContext, (data: any) => {


            if(data.brands)
            setAvailableBrands(data.brands);

            if(data.options)
            setAvailableOptions(data.options);

            if(data.categories){

                const inCats:CategoryData[] = data.categories;
                if(window.location.href.includes("/product-list")){

                    let split = window.location.href.split("/").filter((s)=>s.length>0);

                    let cat = split.pop();

                    if(cat&&!cat.includes("product-list")){

                        cat = cat.toLocaleLowerCase();
                        for(let i = 0;i<inCats.length;i++){
                            if(inCats[i].name.toLocaleLowerCase().replaceAll(' ','-').replaceAll("---","-") == cat){
                                setSelectedCategory(inCats[i].id);

                                break;
                            }
                        }

                    }

                }

                setAvailableCategories(inCats);

            }

            setIsLoading(false);


        }, (data: any) => {
            console.warn("error loading categories");
        });

        return () => {

            if(observer)
                observer.disconnect();

            window.removeEventListener("resize", updateRez);
        }
    }, [])


    useEffect(() => {

        if(isProductListPage && availableCategories.length>0){

            UpdateInventoryByFilters("",page);


        }

    }, [availableCategories])


    const updateRez = ()=>{



        if(containerRef.current){
            setIsMobile(containerRef.current.clientWidth < 768);
            let card = containerRef.current.querySelector(".product-card");
            if(card && card.clientWidth>310){
                setUseHighRes(true);

            }
            else{
                setUseHighRes(false);
            }
        }
    }
    useEffect(() => {

        if (page > totalPages && !isStencil)
            setPage(1);


        updateRez();


    }, [bData])



    useEffect(() => {
        if (!isStencil) {

            UpdateInventoryByFilters(searchText,page);
        }


    }, [ brandFilters, page,optionFilters,selectedCategory])



    const UpdateInventoryByFilters = (text: string,pageNumber:number) => {

        const cat = availableCategories.find((c)=>c.id==selectedCategory);
        const ids = cat?cat.productTypeID:"";

        setMainLoading(true);

        const sText = text ?? searchText;
        GetBusinessProducts(userContext, (data: any) => {

            setBData(data);
            setIsLoading(false);
            setMainLoading(false);
        }, (data: any) => {
            setMainLoading(false);


        }, pageNumber, pagesize, ids, brandFilters,optionFilters,optionSplit, sText);
    }

    const UpdateSearchResults = (text:string)=>{

        setIsDropDownSearchLoading(true);
        GetBusinessProducts(userContext, (data: any) => {

            if(data?.inventorys)
                setDropDownSreachResults(data.inventorys);
            else
                setDropDownSreachResults([]);
            setIsDropDownSearchLoading(false);
        }, (data: any) => {
            setIsDropDownSearchLoading(false);


        }, 0, 100, "", [],[],"", text);
    }

    const items:any[] = bData?.inventorys ?? [];
    const initSearch = () => {
        let text = searchRef.current?.value ?? ""
        setSearchText(text);

        UpdateInventoryByFilters(text,page);
    }



    const FilterChip = useCallback(( {label,onRemove}:{ label:string, onRemove:()=>void } )=>{

        return <div onClick={onRemove}  style={{fontSize:"16px",cursor:"pointer",margin:"4px",padding:"8px",borderRadius:"3px",background:"var(--theme-color-4",color:"var(--theme-color-1)"}} className="flex-row align-center">{label}&nbsp;&nbsp;
        <span style={{fontSize:"1.5em",lineHeight:"0",fontFamily:"serif"}}>&times;</span></div>


    },[]);

    const SelectedFiltersRow = useCallback(() => {

        return <div className="w-full" style={{paddingLeft:"12px"}}>
            <label>Filters:</label>
            <div className="flex-row flex-wrap w-full" style={{paddingLeft:""}}>
                {
                    brandFilters.map((item, index) => {
                        let b = availableBrands?.find((o) => o.id == item);
                        if(!b)
                            return null;
                        return <FilterChip  key={index} label={b?.name ?? ""} onRemove={() => { setBrandFilters(brandFilters.filter((o) => o != item)); }} />

                    })

                }
                {
                    optionFilters.map((item, index) => {

                        let label = item.split(optionSplit)[1];

                        return <FilterChip key={index} label={label} onRemove={() => { setOptionFilters(optionFilters.filter((o) => o != item)); }} />

                    })
                }

                <div onClick={(e) => { e.preventDefault();  setBrandFilters([]); setOptionFilters([]) }} className="v-link" style={{cursor:"pointer", padding: "0px 10px" }}>Clear All</div>
            </div>
            </div>

    }, [brandFilters,optionFilters]);

    const PaginationRow = () => {

        const linkStyle = { textDecoration: "underline", padding: "0px 10px" }

        return <div className="flex-row justify-center gap-med w-full">
            {page > 1 && <button className=" invisible-button v-link" onClick={() => { setPage(page - 1); ;tryScollUp(); }} style={linkStyle}>Previous</button>}

            {page > 1 && <button className="invisible-button v-link" onClick={() => { setPage(page - 1); ;tryScollUp(); }} style={linkStyle}>{page - 1}</button>}

            {totalPages > 1 && <div className="center-all v-button" style={{ padding: "10px" }}>{page}</div>}

            {page < totalPages && <button className="invisible-button v-link" onClick={() => { setPage(page + 1); ; tryScollUp();}} style={linkStyle}>{page + 1}</button>}

            {page < totalPages && <button className="invisible-button v-link" onClick={() => { setPage(page + 1); ; tryScollUp();}} style={linkStyle}>Next</button>}

        </div>

    }

    const showcartLoader =  (isLoading:any) => {
        setIsAddCartLoading(isLoading);
    }


    const isFiltered =  (brandFilters.length > 0 || optionFilters.length >0 )&&showFilters ;

    //if no records found when no filters/search present busienss does not have any online products to display
    if(!mainLoading&&isLoading&&!bData.isStenciled&&page==1&&items.length==0&&brandFilters.length==0&&searchText==""&&optionFilters.length==0){
        return <NoRecordsBanner showInLive={false} message="No Products Found"/>
    }

            return <>
            {isAddCartLoading && <Loader/>}
            <span ref={scrollToRef}></span>
            {isProductListPage&&<h1 style={{height:"48px",paddingLeft:"5px",marginTop:"48px"}} className="w-full">Products</h1>}
                {showFilterPopup && //render outside container to avoid resize observer triggers
                    <>

                        <div className="" style={{ position: "fixed", top: "0", left: "0", width: "100%", height: "100%", zIndex: 5999, background: "var(--default-bg-color)", animation: "max-height-infinity .6s forwards", maxHeight: "0" }}></div>
                        <div id='filter-popup' className="flex-column justify-between" style={{ overflow: "auto", padding: "64px 20px 20px 20px", position: "fixed", top: "0", left: "0", width: "100%", height: "100%", zIndex: 6000, background: "inherit", maxHeight: "0", animation: "max-height-infinity .5s forwards" }}>
                            <div className="w-full" style={{ paddingBottom: "12px" }}>
                                <button style={{ position: "absolute", top: "12px", right: "12px", color: "inherit", padding: "8px" }} className="invisible-button" onClick={() => setShowFilterPopup(false)}><XIcon></XIcon></button>

                                <ProductFilterPanel availableBrands={availableBrands} brandFilters={brandFilters} setBrandFilters={setBrandFilters}
                                    availableCategories={availableCategories} availableOptions={availableOptions}
                                    selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} optionFilters={optionFilters} setOptionFilters={setOptionFilters} />

                            {isFiltered&&<SelectedFiltersRow/>}
                            </div>
                            <button onClick={() => setShowFilterPopup(false)} className="v-button primary w-full">Done</button>
                        </div></>
            }

            {showFilters&&
            <div className={"flex-row-to-column-tablet justify-between w-full "+(availableCategories.length==0&&isStencil&&isProductListPage?"stenciled":"")} style={{padding:"0 6px"}}>
               <BreadCrumbs selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} availableCats={availableCategories}/>
                <div style={{height:"8px"}}></div>

                <div className={"relative flex-row"}  >

                <input ref={searchRef} defaultValue={searchText} placeholder="Search" type="text" className=" w-full" style={{ background: "white", border: "1px solid rgb(199, 199, 199)", borderRadius: "5px", color: "#333", padding: "8px 32px 8px 32px" }}

                    onInput={(e) => {
                        let term = (e.target as HTMLInputElement).value;
                        DelayedSearch(term);

                    }}

                    onKeyDown={(e) => {
                        if (e.key == "Enter")
                            initSearch();

                    }}

                ></input>

                <SearchIcon />

                {searchTerm.length>0&&<button  style={{ position: "absolute", right: "4px", top: "8px"}}className="invisible-button" onClick={()=>{clearSearch();}}><SearchClearIcon/></button>}
                {searchTerm.length>2&&searchRef.current?.parentElement&&
                <GenericTrackedDropdown domTarget={searchRef.current?.parentElement}>
                    {isDropDownSearchLoading&&<div style={{padding:"8px 12px"}}>Searching...</div>}
                    {!isDropDownSearchLoading&&dropDownSreachResults.length==0&&<div style={{padding:"8px 12px"}}>No results found.</div>}
                    {!isDropDownSearchLoading&&dropDownSreachResults.length>0&&searchTerm.length>0&&<div className="flex-column align-start" style={{maxHeight:"300px",overflowY:"auto"}}>

                        {

                            dropDownSreachResults.map((item,index)=>{
                                const link = getProductLinkForHref(item,userContext,"");

                                let lower = item.productName.toLowerCase();
                                let lowerSearch = searchTerm.toLowerCase();


                                let si = lower.indexOf(lowerSearch);
                                let before = (si>-1)?item.productName.substring(0,si):item.productName;
                                let after = (si>-1)?item.productName.substring(si+searchTerm.length):"";
                                let highlight = (si>-1)?item.productName.substring(si,si+searchTerm.length):"";



                                return <a href={link}   className="gray-hover w-full" style={{padding:"8px 12px",cursor:"pointer"}} key={index}>{before}<b>{highlight}</b>{after}</a>
                            })
                        }
                        </div>

                    }


                </GenericTrackedDropdown>
                }
                {isMobile&&showFilters&&  <button className="invisible-button" style={{color:'inherit', marginLeft:"8px",padding:"6px"}}

                onClick={()=>{

                     if(!(window as any).isEditor)
                    setShowFilterPopup(true);

                }}

                >
                <svg xmlns="http://www.w3.org/2000/svg" height={"1.5em"} fill="currentColor" viewBox="0 0 512 512"><path d="M496 72H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v24H16C7.2 72 0 79.2 0 88v16c0 8.8 7.2 16 16 16h208v24c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-24h208c8.8 0 16-7.2 16-16V88c0-8.8-7.2-16-16-16zm0 320H160v-24c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v24H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h80v24c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-24h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm0-160h-80v-24c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v24H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336v24c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-24h80c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"/></svg>
                </button> }
                </div>
                {isMobile&&showFilters&&<div style={{height:"8px"}}></div>}

            </div>
        }

            <div style={{height:"44px",background:(showFilterPopup?"inherit":"")}}></div>
                <div style={{background:(showFilterPopup?"inherit":"")}}  className={"flex-row-to-column-tablet align-start w-full "} ref={containerRef}>

             {showFilters && !isMobile &&  !showFilterPopup &&
                <ProductFilterPanel availableBrands={availableBrands} brandFilters={brandFilters} setBrandFilters={setBrandFilters}
                    availableCategories={availableCategories} availableOptions={availableOptions}
                   selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} optionFilters={optionFilters} setOptionFilters={setOptionFilters} />
             }


                    <div className="flex-row align-start flex-wrap w-full " style={(isLoading||mainLoading)?{opacity:".5"}:{}}>
                    <div className="w-full" style={{transition:"all .3s",overflow:"hidden",height:(isFiltered)?"auto":"72px",maxHeight:((isFiltered)?"148px":"0px")}}>
                    {isFiltered&&
                    <SelectedFiltersRow/>}
                    </div>


                        {(!items || items.length == 0)&&!bData.isStenciled && <NoRecordsBanner showInLive={true} message='No records found.' />}
                        {items.map((item: any, index: number) => {

                            if(index >=limitToFirstX){
                                return null;
                            }

                            return <RenderProductItem forceHighRes={useHighRes} item={item} key={index} siteData={userContext} vertical={true} stencilClass={stencilClass} businessIndex={businessIndex} allowMultiLoc={allowMultiLoc} addTocartLoader={(res:any) =>showcartLoader(res)} />
                        })
                        }
                        {limitToFirstX>= pagesize && <PaginationRow /> }
                        {(isLoading||mainLoading) && <div className="center-all w-full h-full" style={{ position: "absolute", top: "0", left: "0", background: "none", zIndex: "10" }}><EditorLoadingSpinner /></div>}

                    </div>
                </div>
            </>

}

export function GetBusinessIdByIndex(index: number, userContext: UserContext) {

    if (userContext.MultilocationData && userContext.MultilocationData.length > index) {
        return userContext.MultilocationData[index].encBID;
    }

    return userContext.businessId;
}

export function GetIndexOfBusinessIdFromMultiLocation(businessId: string, userContext: UserContext) {


    if (userContext.MultilocationData && userContext.MultilocationData.length > 0) {
        for (let i = 0; i < userContext.MultilocationData.length; i++) {
            if (userContext.MultilocationData[i].encBID == businessId)
                return i;
        }
    }

    return 0;
}

function getRenderProductPrice(item:any)
{
    let price:string = "";
    if(item.inventoryId == "" && item.mySiteInventoryMasterId!= "" || item.type == 2) {
        if(item.minPrice == item.maxPrice)
            price = item.currencySymbol + "" + item.minPrice;
        else
            price = item.currencySymbol + "" + item.minPrice + " - "  + item.currencySymbol + "" + item.maxPrice;
    }
    else {
        price = item.currencySymbol + "" + item.sellingPrice;
    }
    return price;
}

function RenderProductItem({ item, siteData, vertical, stencilClass, businessIndex, allowMultiLoc, addTocartLoader,forceHighRes }: { item: any; siteData: UserContext, vertical: boolean, stencilClass: string, businessIndex: number, allowMultiLoc: any, addTocartLoader:Function,forceHighRes?:boolean }) {



    if (!item.porductName)
        item.porductName = "Unamed";
    if (!item.brandName)
        item.brandName = "";

    let imgURL = item.imagePath??"";
    if(forceHighRes)
        imgURL = imgURL.replace("350x350","800x0");

    var IsEditor = (window as any).isEditor !== undefined ? (window as any).isEditor : false;

    return <a href={(IsEditor)?"#":getProductLinkForHref(item,siteData,"")} className={"vanimation-fade-in no-delay product-card flex-column quarter-third-half-full no-a " + stencilClass} style={{ padding: "10px", color: "inherit", cursor: "pointer", }}
        onClick={(e) =>{if(IsEditor) e.preventDefault();}}>
            <div className="stencil-item" style={{ width: "100%", paddingBottom:  "125%", marginBottom: "4px", backgroundImage: `url(${imgURL})`, backgroundSize: "cover", backgroundPosition: "center", flexShrink: "0",borderRadius:"8px"}}></div>
            <div className="stencil-item max-content"><b>{item.productName}</b></div>
            <div className="stencil-item max-content">{item.brandName}</div>
            <div className="stencil-item max-content">{getRenderProductPrice(item)}</div>

    </a>

}

/*
 !IsEditor && (window as any).renderProdctAddCart(item, siteData, allowMultiLoc, true, "", "", (response:any)=> addTocartLoader(response));
*/
declare global {
    interface Window { renderProdct: any; renderProdctAddCart: any; }
}

window.renderProdctAddCart = function (Item: any, siteData: any, allowMultiLoc: any, isopen: boolean, businessId: any, inventoryID: any, addTocartLoader:Function) {
    if(Item.isGroupMysite) {
        addTocartLoader(true);
        getClustorBusinessData(siteData, "Product", Item.barcodeID, "", Item.multiGroupInventory, (data:any)=>{
            addTocartLoader(false);
            if (data != null && data.data != null && data.data.data != null) {
                Item.multiGroupInventory = data.data.data;
            }
            window.renderProdct(Item, siteData, allowMultiLoc, isopen, businessId, inventoryID);
        },()=>{})
    }
    else {
        window.renderProdct(Item, siteData, allowMultiLoc, isopen, businessId, inventoryID);
    }
}
window.renderProdct = function (Item: any, siteData: any, allowMultiLoc: any, isopen: boolean, businessId: any, inventoryID: any) {

    if (allowMultiLoc && isopen !== false) {
        const multiGroupInventory = Item.multiGroupInventory;
        let Multilocations: any[] = [];
        var businessData = JSON.parse(multiGroupInventory);
        if (!utils.isNullEmptyOrWhiteSpace(multiGroupInventory)) {
            businessData.map((data: any, index: any) => {
                let Data: any[];
                Data = siteData.MultilocationData.filter(
                    (col: any) => col.encBIDHash == data.BID  && isValidLocation(col)
                );
                if (Data.length > 0) {
                    Multilocations.push(Data[0]);
                }
            });
        }
        if (Multilocations.length > 0 && siteData.MultilocationData.length > 1) {
            return ReactDom.render(
                <MultiLocationDropdown
                    Sitedata={Multilocations}
                    OnClickEvent={window.renderProdct}
                    Mode={"productAddCart"}
                    userContext={siteData}
                    Item={Item}
                    allowMultiLoc={allowMultiLoc}
                    isopen={isopen}
                    businessId={businessId}
                />,
                document.getElementById("OpenDialogMultiLocation")
            );
        }
    }

    const BusinessData = utils.MultiLocationData(siteData, siteData.bidHash);
    const linkID = inventoryID != undefined && inventoryID != null && inventoryID != "" ? inventoryID : Item.inventoryIds
    const encBid = businessId != undefined && businessId != null && businessId != "" ? businessId : BusinessData.encBID
    let alink = (Item.isBundle) ? `product-details/bundle/${encBid}/${linkID}` : `product-details/${encBid}/${linkID}`;

    //carry over preview link
    if(window.location.href.endsWith("/preview")||window.location.href.endsWith("/preview/"))
        alink+="/preview";

    window.location.href = alink;
};

function getProductLinkForHref(item: any, siteData: any, businessId: any){


    const BusinessData = utils.MultiLocationData(siteData, siteData.bidHash);
    let inventoryID = item.mySiteInventoryId;
    let masterID = item.mySiteInventoryMasterId;

    let variantString  = "";
    let realID = masterID;
    let isVar = false;
    if(!realID||realID.length<1){

        realID = inventoryID;
        variantString = productURLVariantTag+"/";
        isVar = true;

    }



    // const linkID = inventoryID != undefined && inventoryID != null && inventoryID != "" ? inventoryID : Item.inventoryIds
    const encBid = businessId != undefined && businessId != null && businessId != "" ? businessId : BusinessData.encBID
    //const alink = (item.isBundle) ? `product-details/bundle/${variantString}${encBid}/${realID}` : `product-details/${variantString}${encBid}/${realID}`;
    const alink = GenerateProductURLPrefix(realID,encBid,isVar,item.productName,item.brandName)
    return alink;
}

function SearchIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" fill="#333" style={{ position: "absolute", left: "12px", top: "12px", pointerEvents: "none" }}><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" /></svg>
}

function SearchClearIcon(){
    return <svg height={"1em"} xmlns="http://www.w3.org/2000/svg" fill="currentColor" style={{opacity:".5"}} viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>
}

export function FilterCheckbox({label,isChecked,onChange,nested}:{label:string,isChecked:boolean,onChange?:(on:boolean)=>void,nested?:boolean}){
    return <div className="flex-row align-start" style={{padding:(nested?"8px 8px 8px 32px":"8px"),cursor:"pointer"}}onClick={()=>onChange&&onChange(!isChecked)}>
                <div style={{paddingTop:".2em"}}><CheckSelect isChecked={isChecked}/></div>
                <span  style={{marginLeft:"8px"}} className="w-full">{label}</span>
            </div>
}

function BreadCrumbs({ selectedCategory,setSelectedCategory,availableCats}:{selectedCategory:string,setSelectedCategory:(c:string)=>void,availableCats:CategoryData[]}){

    let current = availableCats.find((c)=>c.id==selectedCategory);

    if(!current) {
        return  <div><span className="v-link stencil-item" style={{fontSize:"14px",fontWeight:"600"}}>All Products <span style={{padding:"0px 4px",visibility:"hidden"}}>{" / "} </span> </span></div>

    }
    const crumbs:CategoryData[] = [current];
    let parent = null;

    do{
        parent = availableCats.find((c)=>c.id==current?.parentCategoryId);
        if(parent){
            crumbs.unshift(parent);
            current = parent;
        }

    }while(parent);

    //always start with a blank "All Products"
    crumbs.unshift({id:"",name:"All Products",parentCategoryId:"",productTypeID:"",total:-1});

    return <div>
        {crumbs.map((crumb,i)=>{

            const notLast = i<crumbs.length-1;

            return <Fragment key = {i}>

             <span
             onClick={()=>setSelectedCategory(crumb.id)}
             className={(notLast?"v-link stencil-item":"stencil-item")} key={i} style={{fontSize:"14px",fontWeight:"600",cursor:(notLast?"pointer":"default")}}>{crumb.name.trim()}</span>
            {notLast&&<span style={{padding:"0px 4px"}}>{" / "} </span>}
            </Fragment>
        })}
    </div>

}

const catStyle = {
    fontSize:"14px",
    fontWeight:"400",
    padding:"8px",
    cursor:"pointer"
}

function  ProductFilterPanel({
    availableBrands,brandFilters,setBrandFilters,
    availableCategories,selectedCategory,setSelectedCategory,
    availableOptions,optionFilters,setOptionFilters}:
    {availableBrands:any,brandFilters:any,setBrandFilters:any,
    availableCategories:CategoryData[],selectedCategory:string,setSelectedCategory:(c:string)=>void
    availableOptions:CategoryOption[],optionFilters:any,setOptionFilters:any,
    }
    ){

    const [openedAccordion,setOpenedAccordion] = useState(-1);

    const toggleAccordion = (index:number)=>{
        if(openedAccordion==index)
            setOpenedAccordion(-1);
        else
            setOpenedAccordion(index);
    }

    let topCats:CategoryData[] = availableCategories.filter((c)=>c.parentCategoryId=="");

    let subCats:CategoryData[] = [];

    if(selectedCategory!="")

    for(let i = 0; i<availableCategories.length; i++){

        if(availableCategories[i].id==selectedCategory){ //if selected category is top category ignore all others.
            topCats = [availableCategories[i]];
            break;
        }
    }

    for(let i = 0; i<availableCategories.length; i++){

        for(let j = 0; j<topCats.length; j++){
            if(availableCategories[i].parentCategoryId==topCats[j].id){
                subCats.push(availableCategories[i]);
                break;
            }
        }

    }



    return <div className="flex-column full-width-tablet" style={{minWidth:"240px"}}>
    {
        <>
        {/* Categories */}
        <FilterAccordion key={"categories"} label={"Category"} isOpen={0==openedAccordion} setIsOpen={()=>{toggleAccordion(0)}}>
            <>{topCats.length>0&&<>
            { topCats.map((tCat:CategoryData,i:number)=>{
                return <Fragment key={i}><div style={{...catStyle,fontWeight:"600"}} onClick={()=>setSelectedCategory(tCat.id)} className="font-bold">{tCat.name+" ("+tCat.total+")"} </div>

                {
                    subCats.map((cat:CategoryData,i:number)=>{

                        if(cat.parentCategoryId!=tCat.id)
                            return null;

                    return <div style={{...catStyle,paddingLeft:"16px"}} key={i} onClick={()=>setSelectedCategory(cat.id)}>{cat.name+" ("+cat.total+")"}</div>

                    })
                }

              </Fragment>})
            }
            </>
            }
            </>
        </FilterAccordion>

        {/* Brands */}
        <FilterAccordion key={"brands"} label={"Brands"} isOpen={1==openedAccordion} setIsOpen={()=>{toggleAccordion(1)}}>
            <>
            {availableBrands&&availableBrands.map((brand:any,i:number)=>{

                return <FilterCheckbox key={i} label={brand.name} isChecked={brandFilters.includes(brand.id)} onChange={(on:boolean)=>{
                    if(on){
                        setBrandFilters([...brandFilters,brand.id]);
                    }
                    else{
                        setBrandFilters(brandFilters.filter((v:string)=>v!=brand.id));
                    }

                }}
                />

            })}
            </>

        </FilterAccordion>

       {/* Options */}
       { availableOptions.map((option:CategoryOption,i:number)=>{

            if(!option.values||option.values.length==0)
                return null;

            return <FilterAccordion key={i+"option"} label={option.key} isOpen={(i+2)==openedAccordion} setIsOpen={()=>{toggleAccordion(i+2)}}>

                    {option.values.map((value:{name:string},j:number)=>{

                        let combined = option.key+optionSplit+ value.name;

                        return <FilterCheckbox key={j} label={value.name} isChecked={optionFilters.includes(combined)} onChange={(on:boolean)=>{
                            if(on){
                                setOptionFilters([...optionFilters,combined]);
                            }
                            else{
                                setOptionFilters(optionFilters.filter((v:string)=>v!=combined));
                            }

                        }}

                        />

                    })}

                </FilterAccordion>
        })
       }
        </>
    }

    </div>

};

export function FilterAccordion({label,isOpen,setIsOpen,children }:{label:string,isOpen:boolean,setIsOpen:Function,children:any}){

    const contentRef = useRef<HTMLDivElement>(null);
    return <div key ={label} className={"v-accordion "+(isOpen?"toggled-on":"") }>
    <div onClick={()=>setIsOpen(!isOpen)} className=" flex-row justify-between align-center accordion-label" style={{fontSize:"15px",fontWeight:"600",padding:"16px 8px"}}>
        <span>{label}</span>

        <AccordionMinus/>

    </div>
    <div  key ={label+"content"} className="accordion-content" style={(isOpen&&contentRef.current?{maxHeight:contentRef.current.clientHeight+100}:{})} >
        <div ref={contentRef} style={{padding:"0px 8px 16px 8px"}}>{children }</div>
    </div>
    <div className="w-full" style={{height:"1px",background:"#cdcdcd"}}></div>
    </div>

}

function AccordionMinus(){
    return <div className="accordion-caret center-all plus-minus " style={{fontSize:"15px"}} >
      <svg className="first" fill="currentColor" height="1em"  xmlns="http://www.w3.org/2000/svg" style={{position:"absolute",transform:"rotateZ(90deg)"}} viewBox="0 0 448 512"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
      <svg className="second" fill="currentColor" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
    </div>
  }